import React from "react";
import { FaUsers, FaGlobe, FaMicrophone, FaLightbulb } from "react-icons/fa";
import "./FeaturesSection.css";

const features = [
  { icon: FaUsers,      title: "Community Practice",  text: "Participate in live group discussions to boost fluency and confidence." },
  { icon: FaGlobe,      title: "Global Connections",  text: "Connect with learners worldwide and exchange ideas in real-time." },
  { icon: FaMicrophone, title: "Expert Feedback",     text: "Receive constructive guidance and personalized feedback from experienced mentors." },
  { icon: FaLightbulb,  title: "Mentor Insights",     text: "Learn from the real-world experience and practical tips of our mentors." },
];

const FeaturesSection = () => (
  <section id="features" className="fs-section">
    <h2 className="fs-title">Why Choose Us?</h2>
    <div className="fs-grid">
      {features.map(({ icon: Icon, title, text }, i) => (
        <div key={i} className="fs-card">
          <div className="fs-icon"><Icon size={40} /></div>
          <h3 className="fs-card-title">{title}</h3>
          <p className="fs-card-text">{text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default FeaturesSection;
